import React from 'react';

import Link from 'next/link';

import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import analytics from '@repo/analytics';
import {
  REFERRALS_INVITE_FRIENDS,
  ReferralsInviteFriendsLabels,
} from '@repo/editor/src/global/analytics/events';
import {
  userStoreSelector,
  useUserStore,
} from '@repo/editor/src/stores/userStore';
import { withEventScope } from '@repo/event-processor';

import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';
import InviteLinkActions from 'components/Subscription/Invites/InviteLinkActions';
import { FlexColumn } from 'styles/layouts';

import { Description, Heading, Wrapper } from './styles';

const trackShare = (type: string) => {
  return (): void => {
    void analytics.track(REFERRALS_INVITE_FRIENDS, {
      type,
      label: ReferralsInviteFriendsLabels.SAP,
    });
  };
};

const ReferralNudgeBanner: React.FC<
  SliceComponentProps<Content.ReferralNudgeBannerSlice>
> = ({ slice }) => {
  const user = useUserStore(userStoreSelector.user);

  if (!user?.slug) {
    return null;
  }

  return (
    <ContentWrapper className="referral-nudge-banner" customWidth="1116px">
      <Wrapper>
        <FlexColumn gap="8px">
          <Heading>Earn up to 3,000 Kittl credits</Heading>
          <Description>
            Get 100 credits for each friend you invite.{' '}
            <Link href="/user/settings/referral" target="_blank">
              Learn more
            </Link>
          </Description>
        </FlexColumn>
        <InviteLinkActions
          mailBody={slice.primary.mailBody ?? undefined}
          mailSubject={slice.primary.mailSubject ?? 'Kittl'}
          slug={user.slug}
          onCopyLinkClick={trackShare('copy')}
          onEmailShareClick={trackShare('email')}
          onWhatsappShareClick={trackShare('whatsapp')}
        />
      </Wrapper>
    </ContentWrapper>
  );
};

export default withEventScope(ReferralNudgeBanner, {
  module: 'referralNudgeBanner',
});
